export default [
    {
        title: 'Contenedores',
        route: 'containers',
        icon: 'BoxIcon',
    },
]